import { graphql } from "../generated/gql";

export const GetCurrentCompany = graphql(`
  query GetCurrentCompany {
    getCompany {
      ID
      plan
      name
      createdAt
      lastTimePlanChanged
      trial {
        callTotalSeconds
        hasTrialCallLimits
        trialEnd
      }
      provider
      tierLevel
    }
  }
`);
